import React, { Component } from 'react';
import { t } from '../../../../locales';
import ScenarioGrantAccess from '../DashboardCardScenario/GrantAccess';
import ScenarioReminder from '../DashboardCardScenario/Reminder';
import ScenarioOverAge from '../DashboardCardScenario/OverAge';
import ScenarioEnrollment from '../DashboardCardScenario/Enrollment';
import ScenarioError from '../DashboardCardScenario/Error';
import newbieImg from '../../../../assets/images/vhis/dashboard/img-newbie@3x.png';
import crytalImg from '../../../../assets/images/vhis/dashboard/img-crystal@3x.png';
import jadeImg from '../../../../assets/images/vhis/dashboard/img-jade@3x.png';
import diamondImg from '../../../../assets/images/vhis/dashboard/img-diamond@3x.png';
import ArrowBlueImg from '../../../../assets/images/vhis/dashboard/arrow-blue.svg';
import {
  AXA_GOAL_LEVEL_CRYSTAL,
  AXA_GOAL_LEVEL_JADE,
  AXA_GOAL_LEVEL_DIAMOND,
  AXA_GOAL_DASHBOARD_SCENARIO_1,
  AXA_GOAL_DASHBOARD_SCENARIO_2,
  AXA_GOAL_DASHBOARD_SCENARIO_3,
  AXA_GOAL_DASHBOARD_SCENARIO_4,
  AXA_GOAL_DASHBOARD_SCENARIO_5,
  AXA_GOAL_DASHBOARD_SCENARIO_6,
} from '../../constants/constants';
import { goto } from '../../../../actions/historyActions';
import './style.scss';

interface DashboardCardProps {
  isShowRedDot: boolean;
  axaGoalLevel: string;
  planName: string;
  policyNumber: string;
  entityCode: string;
  insuredName: string;
  membershipEndDate?: string;
  calAchievedDays: string;
  targetDays: string;
  scenario: string;
}

class DashboardCard extends Component<DashboardCardProps> {
  getLevelImg() {
    const { axaGoalLevel } = this.props;
    if (axaGoalLevel === AXA_GOAL_LEVEL_CRYSTAL) {
      return crytalImg;
    } else if (axaGoalLevel === AXA_GOAL_LEVEL_JADE) {
      return jadeImg;
    } else if (axaGoalLevel === AXA_GOAL_LEVEL_DIAMOND) {
      return diamondImg;
    } else {
      return newbieImg;
    }
  }

  goToSummaryPage() {
    const { policyNumber, entityCode } = this.props;
    if (policyNumber && entityCode) {
      goto(
        `emma-vhis/summary?policyNumber=${policyNumber}&entityCode=${entityCode}`,
      );
    }
  }

  render() {
    const {
      isShowRedDot,
      planName,
      policyNumber,
      entityCode,
      insuredName,
      membershipEndDate,
      calAchievedDays,
      targetDays,
      scenario,
    } = this.props;
    const levelImg = this.getLevelImg();
    const calWidth =
      (parseInt(calAchievedDays, 10) / parseInt(targetDays, 10)) * 100 || 0;
    const progressWidth =
      scenario === AXA_GOAL_DASHBOARD_SCENARIO_4 ? calWidth : 0;
    return (
      <div
        className={`axa-goal-dashboard-card ${
          isShowRedDot ? 'axa-goal-dashboard-card-red-dot' : ''
        }`}
      >
        <div className="axa-goal-dashboard-card-plan-name">{planName}</div>
        <div className="axa-goal-dashboard-card-policy-number">
          PN:{policyNumber}
        </div>
        <div className="axa-goal-dashboard-card-insured-wrap">
          <div className="axa-goal-dashboard-card-insured">
            <div>{t('AXA_GOAL_DASHBOARD_INSURED_NAME')}</div>
            <div className="axa-goal-dashboard-card-insured-bold">
              {insuredName}
            </div>
          </div>
          {membershipEndDate && (
            <div className="axa-goal-dashboard-card-insured">
              <div>{t('AXA_GOAL_DASHBOARD_END_DATE')}</div>
              <div className="axa-goal-dashboard-card-insured-bold">
                {membershipEndDate}
              </div>
            </div>
          )}
        </div>
        {scenario === AXA_GOAL_DASHBOARD_SCENARIO_4 ? (
          <div>
            <div className="axa-goal-dashboard-card-progress">
              <img
                title=""
                alt=""
                src={levelImg}
                className="axa-goal-dashboard-card-progress-img"
              />
              <div className="axa-goal-dashboard-card-progress-content">
                <div className="axa-goal-dashboard-card-progress-top">
                  <div>{t('AXA_GOAL_DASHBOARD_ACHIEVED_DAYS')}</div>
                  <div>
                    <span className="axa-goal-dashboard-card-progress-top-txt">
                      {calAchievedDays}
                    </span>
                    /{targetDays}
                  </div>
                </div>
                <div className="axa-goal-dashboard-card-progress-middle">
                  <div
                    style={{
                      width: `${progressWidth > 100 ? 100 : progressWidth}%`,
                    }}
                  ></div>
                </div>
                <div className="axa-goal-dashboard-card-progress-bottom">
                  {t('AXA_GOAL_DASHBOARD_UPDATED_WITHIN_HOURS')}
                </div>
              </div>
            </div>
            <div
              className="axa-goal-dashboard-card-know-more"
              data-enable-ga
              data-ga-type="button"
              onClick={this.goToSummaryPage.bind(this)}
            >
              <span>{t('AXA_GOAL_DASHBOARD_KNOW_MORE')}</span>
              <img src={ArrowBlueImg} alt="" />
            </div>
          </div>
        ) : (
          <div className="axa-goal-dashboard-card-scenario">
            {scenario === AXA_GOAL_DASHBOARD_SCENARIO_1 && (
              <ScenarioGrantAccess />
            )}
            {scenario === AXA_GOAL_DASHBOARD_SCENARIO_2 && <ScenarioReminder />}
            {scenario === AXA_GOAL_DASHBOARD_SCENARIO_3 && (
              <ScenarioEnrollment
                policyNumber={policyNumber}
                entityCode={entityCode}
              />
            )}
            {scenario === AXA_GOAL_DASHBOARD_SCENARIO_5 && <ScenarioOverAge />}
            {scenario === AXA_GOAL_DASHBOARD_SCENARIO_6 && (
              <ScenarioError policyNumber={policyNumber} />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default DashboardCard;
